<template>
  <div class="batchfiles-container">
    <v-card flat class="futuristic-card">
      <div class="card-header">
        <h1 class="text-md-center earth-color">GENERATING REPORTS</h1>
        <div class="title-decoration"></div>
      </div>
      <v-form @submit.prevent>
        <v-layout row wrap>
          <v-flex lg4 md4 sm12 xs12>
            <v-container>
              <v-dialog
                ref="dialog"
                persistent
                v-model="modal"
                lazy
                full-width
                width="290px"
                :return-value.sync="batchfile.start_date"
              >
                <v-text-field
                  slot="activator"
                  label="Start Date"
                  v-model="batchfile.start_date"
                  readonly
                  class="futuristic-input"
                ></v-text-field>
                <v-date-picker
                  v-model="batchfile.start_date"
                  scrollable
                  class="futuristic-picker"
                >
                  <v-spacer></v-spacer>
                  <v-btn depressed class="futuristic-btn" color="#2196f3" @click="modal = false">Cancel</v-btn>
                  <v-btn depressed class="futuristic-btn" color="#587e27" @click="$refs.dialog.save(batchfile.start_date)">OK</v-btn>
                </v-date-picker>
              </v-dialog>
            </v-container>
          </v-flex>
          <v-flex lg4 md4 sm12 xs12>
            <v-container>
              <v-dialog
                ref="dialog1"
                persistent
                v-model="modal1"
                lazy
                full-width
                width="290px"
                :return-value.sync="batchfile.end_date"
              >
                <v-text-field
                  slot="activator"
                  label="End Date"
                  v-model="batchfile.end_date"
                  readonly
                  class="futuristic-input"
                ></v-text-field>
                <v-date-picker
                  v-model="batchfile.end_date"
                  scrollable
                  class="futuristic-picker"
                >
                  <v-spacer></v-spacer>
                  <v-btn depressed class="futuristic-btn" color="#2196f3" @click="modal1 = false">Cancel</v-btn>
                  <v-btn depressed class="futuristic-btn" color="#587e27" @click="$refs.dialog1.save(batchfile.end_date)">OK</v-btn>
                </v-date-picker>
              </v-dialog>
            </v-container>
          </v-flex>
          <v-flex lg4 md4 sm12 xs12>
            <v-container class="action-buttons">
              <v-btn
                depressed
                color="#587e27"
                class="futuristic-btn action-btn"
                :loading="$loadingTrue"
                @click="requestReport"
              >
                Generate Receipt & Payment
              </v-btn>
              <v-btn
                depressed
                color="#ef5350"
                class="futuristic-btn action-btn"
                :loading="$loadingTrue"
                @click="generateCreditNoteBatchfile"
              >
                Generate Credit Note
              </v-btn>
              <v-btn
                depressed
                color="#2196f3"
                class="futuristic-btn action-btn"
                :loading="this.$store.state.LoadingStore.loading"
                @click="triggerBatchfileGeneeration"
              >
                Generate Today's Batch
              </v-btn>
              <v-btn
  depressed
  color="#8e24aa"
  class="futuristic-btn action-btn"
  :loading="$loadingTrue"
  @click="generateBnlBatchfile"
>
  Generate BNL Batch
</v-btn>
            </v-container>
          </v-flex>
        </v-layout>
      </v-form>
    </v-card>
    <v-card flat class="futuristic-card">
      <div class="card-header">
        <h1 class="text-md-center earth-color">BATCHFILES</h1>
        <div class="title-decoration"></div>
      </div>
      <v-card-title>
        <v-spacer></v-spacer>
        <v-text-field
          append-icon="search"
          placeholder="Search batchfiles..."
          single-line
          hide-details
          v-model="search"
          class="futuristic-input"
        ></v-text-field>
      </v-card-title>
      <v-data-table
        :headers="columns"
        :items="batchFileData"
        :search="search"
        :rows-per-page-items="[10, 25, { text: 'All', value: -1 }]"
        :disable-initial-sort="true"
        :loading="$loadingTrue"
        :expand="expand"
        item-key="name"
        class="futuristic-table"
      >
        <v-progress-linear
          slot="progress"
          color="#587e27"
          indeterminate
          height="3"
        ></v-progress-linear>
        <template slot="items" slot-scope="props">
          <tr @click="props.expanded = !props.expanded">
            <td>{{ formated_date_time(props.item.date_created) }}</td>
            <td class="font-weight-medium">{{ props.item.name }}</td>
            <td>
              <v-btn
                depressed
                color="#2196f3"
                small
                class="futuristic-btn action-btn"
                @click="showTicket(props.item.url)"
              >
                View
              </v-btn>
            </td>
          </tr>
        </template>
        <v-alert slot="no-results" :value="true" color="error" icon="warning" class="futuristic-alert">
          Your search for "{{ search }}" found no results.
        </v-alert>
      </v-data-table>
    </v-card>
  </div>
</template>

<script>
export default {
  name: 'Tickets',
  data () {
    return {
      search: '',
      expand: false,
      dialog1: false,
      dialog: false,
      modal: false,
      modal1: false,
      columns: [
        {
          text: 'Generated On',
          value: 'date_created',
          class: 'table-header'
        },
        {
          text: 'Batchfile CSV',
          value: 'name',
          class: 'table-header'
        },
        {
          text: 'Action',
          value: '',
          class: 'table-header'
        }
      ],
      batchfile: {
        start_date: this.$moment().startOf('month').format('YYYY-MM-DD'),
        end_date: this.$moment().endOf('month').format('YYYY-MM-DD'),
        session_id: localStorage.getItem('lkjhgfdsa')
      }
    }
  },
  methods: {
    showTicket (url) {
      window.open(url, '_blank')
    },
    triggerBatchfileGeneeration () {
      var data = {
        session_id: localStorage.getItem('lkjhgfdsa')
      }
      this.$store.dispatch('generate_batchfile', data)
    },
    generateBnlBatchfile () {
      this.$store.dispatch('generate_bnl_batchfile_by_date', this.batchfile)
    },
    requestReport () {
      this.$store.dispatch('generate_batchfile_by_date', this.batchfile)
    },
    generateCreditNoteBatchfile () {
      this.$store.dispatch('generate_credit_note_batchfile_by_date', this.batchfile)
    }
  },
  created () {
    this.$store.dispatch('get_batchfiles_data')
  }
}
</script>

<style scoped>
/* Futuristic Container */
.batchfiles-container {
  background: #ffffff;
  border-radius: 8px;
  padding: 16px;
  transition: all 0.3s ease;
}

.batchfiles-container:hover {
  box-shadow: 0 6px 20px rgba(0, 0, 0, 0.1);
}

.card-header {
  background: linear-gradient(45deg, #e8eaf6, #f5f7fa);
  padding: 16px;
  border-radius: 8px;
  margin-bottom: 20px;
}

.earth-color {
  color: #587e27;
  font-weight: 600;
  margin: 0;
  font-size: 2rem;
}

.title-decoration {
  height: 4px;
  background: linear-gradient(90deg, #587e27, transparent);
  margin-bottom: 16px;
  width: 100px;
}

.futuristic-card {
  border-radius: 8px;
  background: #ffffff;
  transition: all 0.3s ease;
  overflow: hidden;
}

.futuristic-card:hover {
  box-shadow: 0 6px 20px rgba(0, 0, 0, 0.1);
}

.futuristic-input >>> .v-input__slot {
  border-radius: 8px;
  background: #f5f7fa;
}

.futuristic-btn {
  border-radius: 8px;
  text-transform: none;
  font-weight: 500;
  transition: all 0.2s ease;
}

.futuristic-btn:hover {
  transform: translateY(-1px);
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);
}

.action-btn {
  margin: 4px;
}

.action-buttons {
  display: flex;
  flex-direction: column;
  gap: 12px;
  padding: 16px;
  background: #f5f7fa;
  border-radius: 8px;
}

.futuristic-picker {
  border-radius: 8px;
  background: #ffffff;
}

.futuristic-alert {
  border-radius: 8px;
  margin: 16px;
}

/* Table styling */
.futuristic-table >>> thead tr th {
  background: linear-gradient(45deg, #e8eaf6, #f5f7fa) !important;
  color: #587e27 !important;
  font-weight: 600;
  font-size: 14px;
}

.futuristic-table >>> tbody tr:nth-of-type(even) {
  background-color: #f9f9f9;
}

.futuristic-table >>> tbody tr:hover {
  background-color: #f0f4f8 !important;
}

/* Responsive adjustments */
@media (max-width: 960px) {
  .batchfiles-container {
    padding: 12px;
  }

  .card-header {
    padding: 12px;
  }

  .earth-color {
    font-size: 1.75rem;
  }

  .action-buttons {
    flex-direction: column;
  }

  .action-btn {
    margin: 2px;
  }
}

@media (max-width: 600px) {
  .batchfiles-container {
    padding: 8px;
    border-radius: 6px;
  }

  .card-header {
    padding: 8px;
  }

  .earth-color {
    font-size: 1.5rem;
  }
}
</style>